module.exports = __webpack_public_path__ + "img/student_0.bba831da.png";